import React from 'react';
import { Alert, Text, Heading } from 'localmed-core';
import styled from '@emotion/styled';

const StyledAlert = styled(Alert)`
  text-align: center;
  border-radius: inherit;
`;

export default function PatientScreenerSuccess({ onClose }) {
  return (
    <StyledAlert icon={false} onClose={onClose} tier="success" scrollIntoView>
      <Heading fontWeight="bold" color="white">
        Thank You.
      </Heading>
      <Text>
        Thank you for answering these questions. You have been cleared to schedule an appointment
        with our practice. After you schedule your appointment, you will receive additional
        guidelines regarding your upcoming appointment.
      </Text>
    </StyledAlert>
  );
}
